<template>
  <v-expand-transition>
    <v-bottom-navigation
      v-if="collection && show && smallScreen"
      background-color="white"
      height="64"
      light
      app
      grow
      class="elevation-0"
      color="primary"
    >
      <v-btn class="rounded-xl" icon @click="navigateHome()">
        <span>Back</span>
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-btn
        class="rounded-xl"
        value="overview"
        icon
        :to="{ name: 'caseOverview', params: { uid: $route.params.uid } }"
      >
        <span>Overview</span>
        <v-badge overlap color="warning" :value="openApprovals.length > 0">
          <template v-slot:badge>
            <small>{{ openApprovals.length }}</small>
          </template>
          <v-icon>mdi-format-list-bulleted</v-icon>
        </v-badge>
      </v-btn>
      <v-btn
        class="rounded-xl"
        value="chat"
        icon
        :to="{ name: 'caseChat', params: { uid: $route.params.uid } }"
      >
        <span>Chat</span>
        <v-badge overlap color="primary" :value="unreadMessage > 0">
          <template v-slot:badge>
            <small>{{ unreadMessage }}</small>
          </template>
          <v-icon>mdi-message</v-icon>
        </v-badge>
      </v-btn>
      <v-btn
        class="rounded-xl"
        value="order_forms"
        icon
        :to="{ name: 'caseOrderForms', params: { uid: $route.params.uid } }"
      >
        <span>Order Form</span>
        <v-icon>mdi-clipboard-text</v-icon>
      </v-btn>
      <v-btn
        class="rounded-xl"
        value="order_files"
        icon
        :to="{ name: 'caseOrderFiles', params: { uid: $route.params.uid } }"
      >
        <span>Scans</span>
        <v-icon>mdi-rotate-3d</v-icon>
      </v-btn>
    </v-bottom-navigation>
    <v-navigation-drawer
      v-if="collection && show && !smallScreen"
      app
      clipped
      color="transparent"
      class="pt-3 px-3"
      width="300"
    >
      <v-card class="rounded-xl" color="secondary">
        <v-card-text>
          <v-list rounded dense color="secondary">
            <v-list-item @click="navigateHome()">
              <v-list-item-avatar size="16">
                <v-icon small color="primary"> mdi-arrow-left </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  :class="{ 'black--text': $route.name === 'homePage' }"
                >
                  Back
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-subheader>Case Navigator</v-subheader>
            <v-list-item
              active-class="white"
              :to="{ name: 'caseOverview', params: { uid: $route.params.uid } }"
            >
              <v-list-item-avatar size="16">
                <v-icon small color="primary">
                  mdi-format-list-bulleted
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  :class="{ 'black--text': $route.name === 'caseOverview' }"
                >
                  Case Overview
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              active-class="white"
              :to="{ name: 'caseChat', params: { uid: $route.params.uid } }"
            >
              <v-list-item-avatar size="16">
                <v-icon small color="primary"> mdi-message </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  :class="{ 'black--text': $route.name === 'caseChat' }"
                >
                  Chat
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              active-class="white"
              :to="{
                name: 'caseOrderForms',
                params: { uid: $route.params.uid },
              }"
            >
              <v-list-item-avatar size="16">
                <v-icon small color="primary"> mdi-clipboard-text </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  :class="{ 'black--text': $route.name === 'caseOrderForms' }"
                >
                  Order Form
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              active-class="white"
              :to="{
                name: 'caseOrderFiles',
                params: { uid: $route.params.uid },
              }"
            >
              <v-list-item-avatar size="16">
                <v-icon small color="primary"> mdi-rotate-3d </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title
                  :class="{ 'black--text': $route.name === 'caseOrderFiles' }"
                >
                  Scans
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </v-expand-transition>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CaseNavigator",
  watch: {
    $route(to) {
      if (
        to.name === "caseOverview" ||
        to.name === "caseChat" ||
        to.name === "caseOrderForms" ||
        to.name === "caseOrderFiles"
      ) {
        this.showCaseNavigation();
      } else {
        this.hideCaseNavigation();
      }
    },
  },
  computed: {
    ...mapGetters(["show", "collection", "openApprovals"]),
    unreadMessage() {
      if (!this.collection) {
        return 0;
      }
      if (!this.collection.messages) {
        return 0;
      }
      return this.collection.messages.filter((message) => !message.message_seen)
        .length;
    },
    smallScreen() {
      return (
        this.$vuetify.breakpoint.name === "xs" ||
        this.$vuetify.breakpoint.name === "sm"
      );
    },
  },
  methods: {
    ...mapActions(["showCaseNavigation", "hideCaseNavigation"]),
    navigateHome() {
      this.$router.push({ name: "homePage" });
    },
  },
};
</script>

<style scoped>
.v-navigation-drawer >>> .v-navigation-drawer__border {
  display: none;
}
</style>
